import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { BaseConfirmation } from '../components/base-confirmation/component.js';
import '@alfalab/hooks';
import '../context.js';
import '../utils.js';
import '../types.js';
import '../components/screens/initial/component.js';
import '../../../button/esm/mobile';
import '../../../code-input/esm/desktop';
import '../../../code-input/esm/mobile';
import '../../../link/esm';
import '../../../typography/esm';
import '../components/header/component.js';
import '../countdown-section-7e1d30f1.js';
import '../../../button/esm';
import '../../../spinner/esm';
import '../components/screens/hint/component.js';
import '../components/screens/fatal-error/component.js';
import '../components/screens/temp-block/component.js';
import '../components/countdown-loader/component.js';

var styles = {"container":"confirmation__container_158as"};
require('./mobile.css');

var ConfirmationMobile = function (_a) {
    var className = _a.className, resProps = __rest(_a, ["className"]);
    return (React.createElement(BaseConfirmation, __assign({ mobile: true, className: cn(className, styles.container) }, resProps)));
};

export { ConfirmationMobile };
